import React from 'react';

const InboxSupportPage = () => {
    return (
        <div>
            <h1>{/* InboxSupportPage */}</h1>
        </div>
    );
};

export default InboxSupportPage;


// WEBPACK FOOTER //
// ./src/pages/InboxSupportPage.js